import React from 'react';
import { Popover, Badge } from 'react-bootstrap';

const TaskTagsPopover = ({ task, allTags, onAssignTag, onRemoveTag, ...props }) => {
    const taskTags = task.tags || [];

    const handleTagClick = (tagId, tag) => {
        if (taskTags.find(t => t.id === tagId)) {
            // Updated to pass tagId for remove. 
            // NOTE: The new useTasks expects 'tagId' for remove.
            onRemoveTag(task.id, tagId, tag);
        } else {
            // Updated to pass tag object for assign logic in useTasks
            onAssignTag(task.id, tag);
        }
    };

    return (
        <Popover id={`popover-tags-${task.id}`} {...props}>
            <Popover.Header as="h3">Manage Tags</Popover.Header>
            <Popover.Body>
                <div className="d-flex flex-wrap gap-1">
                    {allTags.map(tag => {
                        const isAssigned = taskTags.find(t => t.id === tag.id);
                        return (
                            <Badge
                                key={tag.id}
                                bg={isAssigned ? 'primary' : 'light'}
                                text={isAssigned ? 'white' : 'dark'}
                                className="cursor-pointer border"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleTagClick(tag.id, tag); }}
                                onPointerDown={(e) => e.stopPropagation()}
                            >
                                {tag.name}
                            </Badge>
                        );
                    })}
                    {allTags.length === 0 && <span className="text-muted small">No tags created yet.</span>}
                </div>
            </Popover.Body>
        </Popover>
    );
};

export default TaskTagsPopover;
